import { Component, EventEmitter, forwardRef, OnInit, Output, ViewChild, Input } from '@angular/core';
import { CompanyService } from '../../../core/services/company.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';

@Component({
  selector: 'app-dropdown-company',
  templateUrl: './dropdown-company.component.html',
  styleUrls: ['./dropdown-company.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DropdownCompanyComponent),
    multi: true
  }]
})
export class DropdownCompanyComponent implements OnInit, ControlValueAccessor {
  @ViewChild('selectModel', { static: true })
  selectModel: NgModel;

  @Input() companyId;
  @Output() onSelected = new EventEmitter();
  @Output() onSelectedObj = new EventEmitter();
  @Output() onListChange = new EventEmitter();


  input = '';
  disabled = false;

  companys = [];

  constructor(private _companyService: CompanyService) { }

  ngOnInit(): void {
    this._companyService.getCompanies()
      .subscribe(res => {
        this.companys = res.model.filter(x => x.isActive == true);
        this.onListChange.emit(this.companys);
        this.onSelectItem({value : this.companyId});
      });
  }

  // ngOnChanges(changes: any) {
  //   this.companyId = changes.companyId.currentValue;
  //   this.onSelectItem({value : changes.companyId.currentValue});
  // }

  onChange = (_) => {};
  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this.input = obj || '';

    if (!obj) {
      this.selectModel.reset('');
    }
  }

  onSelectItem(item): void {
    const _getname = this.companys.filter(x => x.id == item.value)[0];
    if(_getname){
      this.onSelected.emit(_getname);
    }
    else{
      this.onSelected.emit(null);
    }
  }
}
